import { Tldraw } from 'tldraw';
import 'tldraw/tldraw.css';

interface TldrawCanvasProps {
  // Add props as needed
}

function TldrawCanvas(_props: TldrawCanvasProps) {
  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <Tldraw
        persistenceKey="discord-tldraw-canvas"
      />
    </div>
  );
}

export default TldrawCanvas;
